import { render, staticRenderFns } from "./RouteForm.vue?vue&type=template&id=4b1c93f0&"
import script from "./RouteForm.vue?vue&type=script&lang=js&"
export * from "./RouteForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports